/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { useParams, usePathname } from "next/navigation";
import { defaultLocale } from "@i18n/config";
import { MappedLocaleOptionFragment } from "@wf-components/navigation-consumer";
import { getLocaleOptions } from "./localeOptionsFetcher";
import { useEffect, useState } from "react";
import { legalLocaleOptions } from "@site/components/navigation/locale-options";

export const useLocale = (): string => {
	const params = useParams();
	const locale = Array.isArray(params.lang) ? params.lang.join("") : params.lang;
	return locale || defaultLocale;
};

export const useLocaleOptions = (): MappedLocaleOptionFragment[] => {
	const pathname = usePathname();
	const locale = useLocale();
	const [data, setData] = useState<MappedLocaleOptionFragment[]>(legalLocaleOptions);

	useEffect(() => {
		async function fetch(): Promise<void> {
			try {
				const options = await getLocaleOptions(locale, pathname);
				setData(options);
			} catch {
				setData(legalLocaleOptions);
			}
		}
		void fetch();
	}, [locale, pathname]);

	return data;
};
